import {Grid, Typography} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import React from "react";
import {formatPrice} from "../../../actions/actionCreators";

/**
 * This component represents items of Invoice.
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const Item = props => {
    const {bill: {price, count, title} = {}} = props;
    return(
        <Grid container justifyContent={"space-between"}>
            <Grid>
                {props.bill ?
                    <Grid container>
                        <Typography variant={"body1"}>- {title}</Typography>
                        {count && <Typography variant={"body1"}>{'\u00A0'}x{'\u00A0'}</Typography>}
                        <Typography variant={"body1"}>{count || ""}</Typography>
                    </Grid>
                    : <Skeleton width={150}/>
                }
            </Grid>
            <Grid>
                { price ?
                    <Typography variant={"body1"}>{formatPrice(price)}</Typography>
                    : ""
                }
            </Grid>
        </Grid>
    );
};
export default Item;